import { decamelizeKeys } from "humps";
import api from "PFCore/api";
import { Id, MatchedActivity } from "PFTypes";

export const fetchMarketplaceActivity = (id: Id) =>
  api<MatchedActivity["activity"]>({
    url: `marketplace/activities/${id}`
  }).then((res) => decamelizeKeys(res) as MatchedActivity["activity"]); // TODO: [ENG-1712] Remove decamelizeKeys when app is camelized
